var _path, _path2, _circle;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNotificationActiveIcon = function SvgNotificationActiveIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 26C8.84687 26 8.29126 25.5826 8.08535 25H12.9147C12.7087 25.5826 12.1531 26 11.5 26H9.5Z",
    stroke: "#4E4B59",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 13.3758V13.3332V13.3332C17 9.65184 14.0147 6.6665 10.3333 6.6665V6.6665C6.652 6.6665 3.66667 9.65184 3.66667 13.3332V13.3332V13.3758V16.6718C3.66667 17.1038 3.42267 17.4972 3.03733 17.6905L2.36667 18.0252C1.52933 18.4452 1 19.3012 1 20.2372V20.2372C1 21.6025 2.10667 22.7092 3.472 22.7092H17.1947C18.56 22.7092 19.6667 21.6025 19.6667 20.2372V20.2372C19.6667 19.3012 19.1373 18.4452 18.3 18.0265L17.6293 17.6918C17.244 17.4972 17 17.1038 17 16.6718V13.3758Z",
    stroke: "#4E4B59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 5.5,
    r: 4.5,
    fill: "#F82929",
    stroke: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotificationActiveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification_active_icon.478dfe04.svg";
export { ForwardRef as ReactComponent };